import { TextField } from '@fluentui/react';
import CellAddressPicker from '@v2/components/base/CellAddressPicker';
import { FormControl } from '@v2/components/controls/FormControl/FormControl';
import {
  PropertyEditWithDynamicContent
} from '@v2/components/flowsteps/editors/hubspot/objects/PullOjbectHS/PropertyEdit/PropertyEditWithDynamicContent';
import { BaseEditorState } from "@v2/components/flowsteps/editors/common/states/base-editor-state";
import { observer } from "mobx-react";
import React from 'react';
import { ErrorReaction } from 'shared/utils/flowstep';
import SearchableComboBox from 'src/components/base/SearchableComboBox';
import { useStyles } from './AdvancedSettings.styles';

interface AdvancedSettingsProps {
  namePlaceholder?: string;
  timestampCellProps: {
    allowNewSheet?: boolean;
    getTimestampSheetId: () => string;
  }
  baseEditorState: BaseEditorState;
}

export const AdvancedSettings: React.FC<AdvancedSettingsProps> = observer((props) => {
  const {
    namePlaceholder,
    timestampCellProps,
    baseEditorState,
  } = props;

  const { name, errorReaction, protectionPassword, timestampCell } = baseEditorState;
  const showPassword = !baseEditorState.flowstep?.id;

  const {
    allowNewSheet = false,
    getTimestampSheetId,
  } = timestampCellProps;

  const styles = useStyles();

  return (
    <div className={styles.advanced}>
      <TextField
        label="Flow step name"
        value={name} onChange={(_, name) => baseEditorState.name = name || ''}
        placeholder={namePlaceholder}
      />
      <FormControl label="Reaction on error">
        <SearchableComboBox
          placeholder={`Reaction on error`}
          selectedKey={errorReaction}
          onChange={(_, reaction) => baseEditorState.errorReaction = reaction.key}
          options={[
            { key: ErrorReaction.Continue, text: 'Continue' },
            { key: ErrorReaction.Stop, text: 'Stop' },
            { key: ErrorReaction.AskUser, text: 'Ask User' },
          ]}
          disabled={false}
        />
      </FormControl>
      <TextField
        label="Sheet protection password"
        placeholder="Password"
        value={protectionPassword}
        onChange={(_, password) => baseEditorState.protectionPassword = password}
        type={showPassword ? 'text' : 'password'}
      />
      <PropertyEditWithDynamicContent
        label="Last run timestamp cell"
        tooltip={`If you specify a cell address here, we'll write the current 
                   timestamp value to it every time this flow step is executed`}
        className="timestamp-field"
      >
        <CellAddressPicker
          allowEmptyCell
          allowNewSheet={allowNewSheet}
          value={timestampCell}
          onChange={(value) => baseEditorState.timestampCell = value}
          disabled={false}
          localAddressSheetIdGetter={getTimestampSheetId}
        />
      </PropertyEditWithDynamicContent>
    </div>
  )
});
